import React from 'react';

import { Money } from '../../components';

// A selectable deposit amount. A real toggle button: the old `<div onClick>`
// was neither focusable nor keyboard-activatable.
export function Deposit({
  amount,
  // Currency code for the amount; omitted → store base (Money default).
  currency,
  selected,
  disabled,
  onClick,
  className = '',
}) {
  return (
    <button
      type="button"
      className={`checkout-deposit ${className}`.trim()}
      aria-pressed={Boolean(selected)}
      disabled={Boolean(disabled)}
      onClick={disabled ? undefined : onClick}
    >
      <Money amount={amount} currency={currency} />
    </button>
  );
}
